import { GetStaticProps } from 'next';
import { bffService } from '@thisisdevelopment/akzonobel-core';
import { ContainerInner, Page, Wysiwyg, PageType } from '@thisisdevelopment/heritage-core-library';
import NextHead from '@/components/NextHead';
import metas from '@/routes/meta';
import { pageRevalidate } from '../../../src/config';

type SSRProps = {
  page: PageType;
};

function Policy({ page }: SSRProps) {
  const meta = metas.default;

  return (
    <div>
      <NextHead meta={meta} />
      <Page title={page.title}>
        <ContainerInner my="80px">
          <Wysiwyg content={page.text} />
        </ContainerInner>
      </Page>
    </div>
  );
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const page = await bffService
    .getCmsItemBySlug('policy_pages', params?.slug as string)
    .then((r) => r.data.data);
  return {
    props: { page },
    revalidate: pageRevalidate,
  };
};

export async function getStaticPaths() {
  const pages = await bffService.getCmsItem('policy_pages').then((r) => r.data.data);
  const paths = pages.map((p: PageType) => ({
    params: { slug: p.slug },
  }));
  return {
    paths,
    fallback: false,
  };
}

export default Policy;
